export const getRequiredPermissionForPath = (path) => {
  if (!path || path === "/access-denied") {
    return null;
  }

  if (path === "/") {
    return { module: "Dashboard", action: "view" };
  }

  const p = path.toLowerCase();

  let action = "view";
  if (p.includes("/add") || p.includes("/create")) {
    action = "add";
  } else if (p.includes("/edit")) {
    action = "edit";
  }

  if (p.startsWith("/banner")) return { module: "Banner", action };
  if (p.startsWith("/testimonial")) return { module: "Testimonials", action };
  if (p.startsWith("/advertisement")) return { module: "Advertisement", action };
  if (p.startsWith("/youtube")) return { module: "Youtube", action };

  if (p.startsWith("/category")) return { module: "Category", action };
  if (p.startsWith("/sub-category")) return { module: "Sub Category", action };
  if (p.startsWith("/child-category")) return { module: "Child Category", action };
  if (p.startsWith("/brands")) return { module: "Brands", action };
  if (p.startsWith("/attributes")) return { module: "Attributes", action };
  if (p.startsWith("/units")) return { module: "Unit", action };
  if (p.startsWith("/taxes")) return { module: "Tax", action };
  if (p.startsWith("/products")) return { module: "Products", action };
  if (p.startsWith("/coupons")) return { module: "Coupons", action };
  if (p.startsWith("/shipping-methods")) return { module: "Shipping Methods", action };

  if (
    p.startsWith("/all-orders") ||
    p.startsWith("/customer-orders") ||
    p.startsWith("/cancelled-orders") ||
    p.startsWith("/return-orders")
  ) {
    return { module: "All Orders", action };
  }
  if (p.startsWith("/paid-orders")) return { module: "Paid Orders", action };
  if (p.startsWith("/unpaid-orders")) return { module: "Failed Orders", action };
  if (p.startsWith("/unfulfilled-orders")) return { module: "Unfulfilled Orders", action };
  if (p.startsWith("/dispatched-orders")) return { module: "Dispatched Orders", action };
  if (p.startsWith("/orders-feedback")) return { module: "Customer Reviews", action };

  if (p.startsWith("/roles-permissions") || p.startsWith("/user-roles")) return { module: "Role & Permission", action };
  if (p.startsWith("/admin-registration")) return { module: "Admin Users", action };
  if (p.startsWith("/activity-logs")) return { module: "Activity Logs", action };
  if (p.startsWith("/customer-list")) return { module: "Customer List", action };
  if (p.startsWith("/notify-me")) return { module: "Notify Me", action };
  if (p.startsWith("/contact-us")) return { module: "Contact Us", action };

  if (p.startsWith("/vendor-list") || p.startsWith("/vendor-payment")) return { module: "Vendor", action };
  if (p.startsWith("/purchase-entry")) return { module: "Purchase Entry", action };

  if (p.startsWith("/payment-history")) return { module: "Payment History", action };
  if (p.startsWith("/manual-payment")) return { module: "Manual Payment", action };
  if (p.startsWith("/inventory-list")) return { module: "Inventory List", action };
  if (p.startsWith("/add-stock")) return { module: "Add Stock", action };

  if (p.startsWith("/product-reports")) return { module: "Product Reports", action };
  if (p.startsWith("/customer-reports")) return { module: "Customer Reports", action };
  if (p.startsWith("/vendor-reports")) return { module: "Vendor Reports", action };
  if (p.startsWith("/payment-reports")) return { module: "Payment Reports", action };
  if (p.startsWith("/sales-reports")) return { module: "Sales Reports", action };
  if (p.startsWith("/stock-reports")) return { module: "Stock Reports", action };

  if (p.startsWith("/pos-order")) return { module: "POS Order", action };
  if (p.startsWith("/pos-history")) return { module: "POS Order History", action };

  return null;
};

export const getFirstPermittedRoute = (hasPermission) => {
  if (hasPermission("Dashboard", "view")) return "/";

  const moduleRoutePairs = [
    { module: "Banner", route: "/banner" },
    { module: "Testimonials", route: "/testimonials" },
    { module: "Advertisement", route: "/advertisement" },
    { module: "Youtube", route: "/youtube" },
    { module: "Category", route: "/category" },
    { module: "Sub Category", route: "/sub-category" },
    { module: "Child Category", route: "/child-category" },
    { module: "Attributes", route: "/attributes" },
    { module: "Tax", route: "/taxes" },
    { module: "Products", route: "/products" },
    { module: "Coupons", route: "/coupons" },
    { module: "Shipping Methods", route: "/shipping-methods" },
    { module: "All Orders", route: "/all-orders" },
    { module: "Paid Orders", route: "/paid-orders" },
    { module: "Failed Orders", route: "/unpaid-orders" },
    { module: "Unfulfilled Orders", route: "/unfulfilled-orders" },
    { module: "Dispatched Orders", route: "/dispatched-orders" },
    { module: "Customer Reviews", route: "/orders-feedback" },
    { module: "Role & Permission", route: "/roles-permissions" },
    { module: "Admin Users", route: "/admin-registration" },
    { module: "Activity Logs", route: "/activity-logs" },
    { module: "Customer List", route: "/customer-list" },
    { module: "Notify Me", route: "/notify-me" },
    { module: "Contact Us", route: "/contact-us" },
    { module: "Vendor", route: "/vendor-list" },
    { module: "Purchase Entry", route: "/purchase-entry" },
    { module: "Payment History", route: "/payment-history" },
    { module: "Inventory List", route: "/inventory-list" },
    { module: "Add Stock", route: "/add-stock" },
    { module: "Customer Reports", route: "/customer-reports" },
    { module: "Payment Reports", route: "/payment-reports" },
    { module: "Stock Reports", route: "/stock-reports" },
    { module: "Sales Reports", route: "/sales-reports" },
  ];

  for (const pair of moduleRoutePairs) {
    if (hasPermission(pair.module, "view")) {
      return pair.route;
    }
  }

  return "/access-denied";
};
